import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router";
import AuthService from "../../services/authService";

const ProtectedRoute: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      try {
        const decodedToken = AuthService.getUserRole();
        if (!decodedToken) {
          AuthService.logout();
        }
      } catch {
        AuthService.logout();
      }
    }
  }, []);

  if (!AuthService.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;
